export const MUT_GET_FIATS = 'MUT_GET_FIATS';
export const MUT_SET_FIATS = 'MUT_SET_FIATS';
export const MUT_ERR_FIATS = 'MUT_ERR_FIATS';
